var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M5.5 1.188v8.624M10 5.5H1","stroke":"currentColor","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }